import { useEffect } from 'react';

/**
 * Atalhos de TV:
 *  F = toggle fullscreen
 *  R = recarrega (reset estado WS+app)
 *  1/2/3 = troca view (callback opcional)
 */
export function useTvShortcuts(onSwitch?: (view: 'geral' | 'rede' | 'comercial') => void) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.target && (e.target as HTMLElement).tagName.match(/INPUT|TEXTAREA/)) return;
      if (e.key === 'f' || e.key === 'F') {
        if (!document.fullscreenElement) document.documentElement.requestFullscreen?.();
        else document.exitFullscreen?.();
      } else if (e.key === 'r' || e.key === 'R') {
        window.location.reload();
      } else if (onSwitch && (e.key === '1' || e.key === '2' || e.key === '3')) {
        const m = { '1': 'geral', '2': 'rede', '3': 'comercial' } as const;
        onSwitch(m[e.key as keyof typeof m]);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onSwitch]);
}
